import SvgIcon, { SvgIconProps } from "./SvgIcon";

const SocialIcon: React.FC<SvgIconProps> = ({
  variant = "contained",
  ...props
}) => {
  return (
    <SvgIcon {...props}>
      {variant == "contained" ? (
        <>
          <g clipPath="url(#clip0_2955_65)">
            <path
              d="M15.3313 16.757C14.9353 17.3491 14.0647 17.3491 13.6688 16.757L12.2263 14.6H7.7C7.2325 14.6 6.83229 14.4335 6.49938 14.1006C6.16646 13.7677 6 13.3675 6 12.9V2.7C6 2.2325 6.16646 1.83229 6.49938 1.49938C6.83229 1.16646 7.2325 1 7.7 1H21.3C21.7675 1 22.1677 1.16646 22.5006 1.49938C22.8335 1.83229 23 2.2325 23 2.7V12.9C23 13.3675 22.8335 13.7677 22.5006 14.1006C22.1677 14.4335 21.7675 14.6 21.3 14.6H16.7738L15.3313 16.757ZM14.084 14.316C14.2819 14.6128 14.7181 14.6128 14.916 14.316L15.7116 13.1227C15.8043 12.9836 15.9604 12.9 16.1276 12.9H21.3V2.7H7.7V12.9H12.8724C13.0396 12.9 13.1957 12.9836 13.2884 13.1227L14.084 14.316Z"
              fill="currentColor"
              stroke="currentColor"
              strokeWidth="0.3"
            />
            <path
              d="M11.3313 21.757C10.9353 22.3491 10.0647 22.3491 9.66875 21.757L7.95875 19.2H2.9C2.3775 19.2 1.93021 19.014 1.55813 18.6419C1.18604 18.2698 1 17.8225 1 17.3V5.9C1 5.3775 1.18604 4.93021 1.55813 4.55813C1.93021 4.18604 2.3775 4 2.9 4H18.1C18.6225 4 19.0698 4.18604 19.4419 4.55813C19.814 4.93021 20 5.3775 20 5.9V17.3C20 17.8225 19.814 18.2698 19.4419 18.6419C19.0698 19.014 18.6225 19.2 18.1 19.2H13.0413L11.3313 21.757Z"
              fill="black"
            />
            <path
              d="M13.5028 12.4736V12.5963M14 12.5C14 12.7761 13.7759 13 13.4998 13C13.2237 13 13 12.7761 13 12.5C13 12.2237 13.2237 12 13.4998 12C13.7759 12 14 12.2237 14 12.5Z"
              stroke="white"
              strokeWidth="1.44"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.5029 12.4736V12.5963M8 12.5C8 12.7761 7.77598 13 7.49986 13C7.22372 13 7 12.7761 7 12.5C7 12.2237 7.22372 12 7.49986 12C7.77598 12 8 12.2237 8 12.5Z"
              stroke="white"
              strokeWidth="1.44"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_2955_65">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </>
      ) : (
        <>
          <g clipPath="url(#clip0_2955_64)">
            <path
              d="M14.9062 17.607C14.5102 18.1991 13.6396 18.1991 13.2437 17.607L11.6875 15.28H6.9349C6.44403 15.28 6.02381 15.1052 5.67425 14.7557C5.32468 14.4061 5.1499 13.9859 5.1499 13.495V2.785C5.1499 2.29413 5.32468 1.87391 5.67425 1.52434C6.02381 1.17478 6.44403 1 6.9349 1H21.2149C21.7058 1 22.126 1.17478 22.4756 1.52434C22.8251 1.87391 22.9999 2.29413 22.9999 2.785V13.495C22.9999 13.9859 22.8251 14.4061 22.4756 14.7557C22.126 15.1052 21.7058 15.28 21.2149 15.28H16.4623L14.9062 17.607ZM13.6589 15.013C13.8568 15.3098 14.293 15.3098 14.4909 15.013L15.3545 13.7177C15.4472 13.5786 15.6033 13.495 15.7705 13.495H21.2149V2.785H6.9349V13.495H12.3793C12.5465 13.495 12.7026 13.5786 12.7953 13.7177L13.6589 15.013Z"
              fill="currentColor"
              stroke="currentColor"
              strokeWidth="0.3"
            />
            <path
              d="M2.90039 5H18.0996C18.3548 5 18.5483 5.07958 18.7344 5.26562C18.9204 5.45167 19 5.64521 19 5.90039V17.2998C19 17.555 18.9204 17.7485 18.7344 17.9346C18.5484 18.1205 18.3547 18.2002 18.0996 18.2002H12.5068L12.21 18.6445L10.5 21.2012L8.79004 18.6445L8.49316 18.2002H2.90039C2.64526 18.2002 2.45164 18.1205 2.26562 17.9346C2.07958 17.7485 2 17.555 2 17.2998V5.90039C2 5.64522 2.07958 5.45167 2.26562 5.26562C2.42829 5.10296 2.59632 5.02169 2.80664 5.00391L2.90039 5Z"
              fill="white"
              stroke="currentColor"
              strokeWidth="2"
            />
            <path
              d="M13.5028 12.4736V12.5963M14 12.5C14 12.7761 13.7759 13 13.4998 13C13.2237 13 13 12.7761 13 12.5C13 12.2237 13.2237 12 13.4998 12C13.7759 12 14 12.2237 14 12.5Z"
              stroke="currentColor"
              strokeWidth="1.44"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.5029 12.4736V12.5963M8 12.5C8 12.7761 7.77598 13 7.49986 13C7.22372 13 7 12.7761 7 12.5C7 12.2237 7.22372 12 7.49986 12C7.77598 12 8 12.2237 8 12.5Z"
              stroke="currentColor"
              strokeWidth="1.44"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_2955_64">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </>
      )}
    </SvgIcon>
  );
};

export default SocialIcon;
